// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { ReactElement } from 'react';

/**
 * Component exists for future optimizations
 * See: https://necolas.github.io/react-native-web/docs/?path=/docs/components-flatlist--single-column
 * @param children
 * @constructor
 */
export const AccordionItem: React.FCWithChildren = ({ children }) => (children as ReactElement);

export default AccordionItem;
